import React, {useCallback, useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {useDispatch, useSelector, useStore} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import {changeAnswer} from "../../modules/answers";
import {changeVisible, setSurveyData} from "../../modules/survey";
import {changeState, setHidden, setSelectedItem} from "../../modules/menu";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState,
    userState
} from "../../state/globalState";
import {getCommCode} from "../../lib/api/code";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: '300px'
    },
    textFieldMobile: {
        width: '250px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey2 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [natList, setNatList] = useState([]);
    const [natCodeList, setNatCodeList] = useState([]);
    const [isDisplay, setIsDisplay] = useState(false);
    const classes = useStyles();
    const isKor = answer.IS_KOR;

    const getCommCodeList = async (gropCd) => {
        const { data } = await getCommCode(gropCd)
        setNatCodeList(data.payload);
    };

    useEffect(() => {
        getCommCodeList("CO034");
        // const tmpNatCd = JSON.parse(localStorage.getItem("CO034"));
    }, []);


    useEffect(() => {
        const tmpNatList = natCodeList.map((item) => {
            if (item.commDetlsCd !== 'CO0340KR') {
                return (
                    <MenuItem key={item.commDetlsCd} value={item.commDetlsCd}>{item.detlsCdNm}</MenuItem>
                )
            }
        });
        setNatList(tmpNatList);
    }, [natCodeList]);

    const handleInputAnswer = (e, column) => {
        const { value, name } = e.target;
        const rel = surveyData[7].rel;
        let key = null;

        if ("natlGcd" === column) {
            key = 'SURVEY_8';

            setAnswer({
                ...answer,
                [column]: value
            });

        } else {
            key = 'SURVEY_7';

            if ("1" === value) {
                const newState = {
                    ...answer,
                    [column]: value,
                    natlGcd: 'CO0340KR'
                }

                setAnswer(newState)// }));
            } else {
                const newState = {
                    ...answer,
                    [column]: value,
                    natlGcd: ''
                }

                setAnswer(newState)// }));
            }
        }

        setSelectedMenuItem(key);
        setMenuCheck(value !== '');

        if (rel !== undefined && name === 'true') {
            setIsDisplay(false);
        } else if (rel !== undefined && name === 'false') {
            setIsDisplay(true);
        }

    };

    const StyledRadio = (props) => {
        return (
            <Radio
                key={'survey-' + props.key}
                disableRipple
                color="default"
                checked={isKor === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'IS_KOR')}
                {...props}
            />
        );
    };

    const step7List = surveyData[7].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'7-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio key='rd-step-7' />} label={item.content}/>
            </>
        )
    });

    return (
        <>
            <ScrollableAnchor id={"7"}>
                <div>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[7].title}
                            sentences={surveyData[7].questions}
                            step={7}
                        />
                        <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            {/*<Divider />*/}
                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                {step7List}
                            </RadioGroup>
                            {/*<Divider />*/}
                        </FormControl>
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"8"}>
                <div style={{display: isDisplay ? "block" : "none"}}>
                <Container>
                    <FormControl variant="filled" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-filled-label">
                            국적
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-filled-label"
                            id="demo-simple-select-filled"
                            style={{width: 250}}
                            value={answer.natlGcd === 'CO0340KR' ? "" : answer.natlGcd}
                            defaultValue=""
                            onChange={(e) => handleInputAnswer(e, surveyData[8].column)}
                        >
                            {natList}
                        </Select>
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey2;
